import styles from "./Author.module.scss";

export default function Author({ post }) {
  return (
    <section className={styles["Author"]}>
      {post?.primary_author?.profile_image && (
        <img src={post.primary_author.profile_image} height={80} width={80} />
      )}
      <div className={styles["Author__heading"]}>
        {post.primary_author.name}
      </div>
    </section>
  );
}
